import Vue from "vue"
import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
import Router from "vue-router"


import Index from "@/components/Index"
import Home from "@/components/Home"
import ManageProducts from "@/components/ManageProducts"
import ManagePurchaseOrders from "@/components/ManagePurchaseOrders"
import ManageInventory from "@/components/ManageInventory"
import ManageLocations from "@/components/ManageLocations"
import ManageSales from "@/components/ManageSales"
//import ManageUsers from "@/components/ManageUsers"
import ListUsers from "@/components/Users/ListUsers"
import UsersMain from "@/components/Users/UsersMain"

import UserProfile from "@/components/importables/UserProfile"
import ResetPassword from "@/components/importables/ResetPassword"
import CustomerMain from "../components/Customers/CustomerMain.vue"
import AdminApproval from "@/components/Sales/AdminApproval"
import CheckinScreen from "@/components/Visitor/CheckinScreen";
import OwnerDashboard from "@/components/Visitor/OwnerDashboard";
import VisitorSettings from "@/components/Visitor/Settings";


import ManageTools from "@/components/ManageTools"
import NewSales from "@/components/NewSales"
import ListProducts from "@/components/ListProducts"
import AddProductGroup from "@/components/AddProductGroup"
import AddInventory from "@/components/AddInventory"
import RequestItems from "@/components/RequestItems"
import MyRequests from "@/components/MyRequests"
import LookupProduct from "@/components/LookupProduct"
import ProductCatalog from "@/components/Products/ProductCatalog"
import ViewProduct from "@/components/ViewProduct"
import ListLocations from "@/components/Locations/ListLocations"
import LocationsMain from "@/components/Locations/LocationsMain"
//import ListCategories from "@/components/ListCategories"
//import ListVendors from "@/components/ListVendors"
//import ListSublocations from "@/components/ListSublocations"
import ListInventoryProducts from "@/components/ListInventoryProducts"
import ListSales from "@/components/Sales/ListSales"
import DeliveryZones from "@/components/DeliveryZones"
import AccountingMain from "@/components/Accounting/AccountingMain"

import GeneratePullist from "@/components/GeneratePullist"
import DeliveryList from "@/components/DeliveryList"
import ListDeliveryLists from "@/components/ListDeliveryLists"
import ListPullists from "@/components/ListPullists"
import ViewPullist from "@/components/ViewPullist"
import ViewInvoice from "@/components/ViewInvoice"

import TransferRequests from "@/components/TransferRequests"
import Inventory from "@/components/Inventory"
import Sales from "@/components/Sales"
//import ItemsToPull from "@/components/ItemsToPull"
import Scanner from "@/components/Scanner"
import PickAndDrop from "@/components/PickAndDrop"

import NewSale from "@/components/Sales/NewSale"
import LookupSale from "@/components/Sales/LookupSale"
import ViewSaleWrapper from "@/components/Sales/ViewSaleWrapper"
import MyCustomerDeliveries from "@/components/Sales/MyCustomerDeliveries"
import EditInvoiceWrapper from "@/components/Sales/EditInvoiceWrapper"

import Refunds from "@/components/Sales/Refunds"
import ProcessRefunds from "@/components/Sales/ProcessRefunds"

import ReceivingFloorSamples from "@/components/Receiving/ReceivingFloorSamples"
import ReceivingInventory from "@/components/Receiving/ReceivingInventory"
import ReceivingCustomerPickup from "@/components/Receiving/ReceivingCustomerPickup"


import ShippingMain from "@/components/Shipping/ShippingMain";
import ShippingCustomerPickup from "@/components/Shipping/ShippingCustomerPickup"
import ShippingItemsShipped from "@/components/Shipping/ShippingItemsShipped"
import ShippingItemsToPull from "@/components/Shipping/ShippingItemsToPull"

import LookupInventory from "@/components/Inventory/LookupInventory"

import AdminToolsOpenRequests from "@/components/AdminTools/AdminToolsOpenRequests"
import AdminToolsCreatePullist from "@/components/AdminTools/AdminToolsCreatePullist"
import AdminToolsItemsToBePulled from "@/components/AdminTools/AdminToolsItemsToBePulled"
import AdminToolsItemsToBePicked from "@/components/AdminTools/AdminToolsItemsToBePicked"
import AdminToolsAllOrders from "@/components/AdminTools/AdminToolsAllOrders"
import AdminToolsAllOrders2 from "@/components/AdminTools/AdminToolsAllOrders2"
import AdminToolsMarkItemsReadyToShip from "@/components/AdminTools/AdminToolsMarkItemsReadyToShip"
import AdminToolsCreateDeliveries from "@/components/AdminTools/AdminToolsCreateDeliveries"
import AdminToolsHomeDeliveries from "@/components/AdminTools/AdminToolsHomeDeliveries"
import AdminToolsStorePickups from "@/components/AdminTools/AdminToolsStorePickups"
import AdminToolsStoreTransfers from "@/components/AdminTools/AdminToolsStoreTransfers"
import AdminToolsVendorOrders from "@/components/AdminTools/AdminToolsVendorOrders"
import AdminToolsProcessDeliveries from "@/components/AdminTools/AdminToolsProcessDeliveries"
import AdminToolsProcessPickups from "@/components/AdminTools/AdminToolsProcessPickups"

import ReceivingMain from '@/components/Receiving/ReceivingMain.vue'


import GenerateGiftCards from "@/components/GiftCard/GenerateGiftCards.vue"
import GiftCardManagement from "@/components/GiftCard/GiftCardManagement.vue"
import GiftCardView from "@/components/GiftCard/GiftCardView.vue"
import GiftCardBatch from "@/components/GiftCard/GiftCardBatch.vue"

import IncomingOutGoingIncoming from "@/components/IncomingOutGoing/IncomingOutGoingIncoming"
import IncomingOutGoingOutGoing from "@/components/IncomingOutGoing/IncomingOutGoingOutGoing"
import IncomingOutgoing from "@/components/IncomingOutGoing/IncomingOutgoing"
import ItemsToPull from "@/components/IncomingOutGoing/ItemsToPull"
import DeliveriesLoading from "@/components/IncomingOutGoing/DeliveriesLoading"
import DeliveriesShipping from "@/components/IncomingOutGoing/DeliveriesShipping"

//import ListCustomerServiceTickets from "@/components/CustomerService/ListCustomerServiceTickets"
import CustomerServiceMain from "@/components/CustomerService/CustomerServiceMain"
import CSTicket from "@/components/CustomerService/CSTicket"

import ProductsListProducts from "@/components/Products/ProductsListProducts"

// import ReportsReportsV1 from "@/components/Reports/ReportsReportsV1"
// import ReportsStoresSale from "@/components/Reports/ReportsStoresSale"
// import ReportsMySales from "@/components/Reports/ReportsMySales"
// import ReportsRefunds from "@/components/Reports/ReportsRefunds"
import ReportsMain from "@/components/Reports/ReportsMain"
import ProductReportsMain from "@/components/ProductReports/ProductReportsMain"

//import UsersListUsers from "@/components/Users/UsersListUsers"
import DeliveriesListDeliveries from "@/components/Deliveries/DeliveriesListDeliveries"

import PurchaseOrder from "@/components/PurchaseOrders/PurchaseOrder"
import ListPurchaseOrders from "@/components/PurchaseOrders/ListPurchaseOrders"
import ListSpecialOrders from "@/components/PurchaseOrders/ListSpecialOrders"

import InventoryByLocation from "@/components/Inventory/InventoryByLocation"
import InventoryMain from "@/components/Inventory/InventoryMain"
import AddProducts from "@/components/Products/AddProducts"
import DeliveryCalendarMain from "@/components/DeliveryCalendar/DeliveryCalendarMain"  
import AdminToolsMain from "@/components/AdminTools/AdminToolsMain"
import ShippingReceivingMain from "@/components/IncomingOutGoing/ShippingReceivingMain"
import ProductsMain from "@/components/Products/ProductsMain"
import SalesMain from "@/components/Sales/SalesMain"


import ControlPanelMain from "@/components/ControlPanel/ControlPanelMain"


import NewTransfer from "@/components/StoreTransfers/NewTransfer"

import RefundProcess from "@/components/Sales/RefundProcess"


//import GeoAgent from "@/components/AdminTools/GeoAgent"


import VendorOrdersMain from "@/components/VendorOrders/VendorOrdersMain"
import TransferOrdersMain from "@/components/TransferOrders/TransferOrdersMain"

import NotificationPage from "@/components/Notifications/NotificationPage";



import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router)
Vue.use(BootstrapVue)

const IsUserAuthed = function(){
    const token = localStorage.getItem("userToken");
    
    if (!token){
        return false;
    }
    
    // Check if token is expired
    try {
        // Simple JWT decode to check expiration
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        
        // Check if token has expired
        if (payload.exp && payload.exp < currentTime) {
            // Token expired, clear localStorage
            localStorage.removeItem("userToken");
            localStorage.removeItem("userDetails");
            localStorage.removeItem("packet");
            return false;
        }
        
        return true;
    } catch (error) {
        // If we can't decode, assume token is invalid
        localStorage.removeItem("userToken");
        localStorage.removeItem("userDetails");
        localStorage.removeItem("packet");
        return false;
    }
}


const AlwaysAllow = function(){
  return true
}

export default new Router({
    mode: "hash",
    routes: [
      {
          path: "/",
          name: "Index",
          component: Index,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: "/home/",
              falsePath: null
          }
      },
      {
          path: "/home/",
          name: "Home",
          component: Home,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
        path: "/accounting/main/",
        name: "AccountingMain",
        component: AccountingMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
          path: "/sales/manage/",
          name: "ManageSales",
          component: ManageSales,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/sales/new/",
          name: "NewSales",
          component: NewSales,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
       {
        path: '/gift-card/generate',
        name: 'GenerateGiftCards',
        component: GenerateGiftCards,
        meta: {
          conditionalRoute: true,
          stopornot: IsUserAuthed,
          truePath: null,
          falsePath: "/"
        }
      },
      {
        path: '/gift-card/management',
        name: 'GiftCardManagement',
        component: GiftCardManagement,
        meta: {
          conditionalRoute: true,
          stopornot: IsUserAuthed,
          truePath: null,
          falsePath: "/"
        }
      },
      {
        path: '/gift-card/view/:id',
        name: 'GiftCardView',
        component: GiftCardView,
        meta: {
          conditionalRoute: true,
          stopornot: IsUserAuthed,
          truePath: null,
          falsePath: "/"
        }
      },
      {
        path: '/gift-card/batch/:batchId',
        name: 'GiftCardBatch',
        component: GiftCardBatch,
        meta: {
          conditionalRoute: true,
          stopornot: IsUserAuthed,
          truePath: null,
          falsePath: "/"
        }
      },
      {
          path: "/sales/refund_process/",
          name: "RefundProcess",
          component: RefundProcess,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      
      {
          path: "/products/manage/",
          name: "ManageProducts",
          component: ManageProducts,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/purchase_orders/manage/",
          name: "ManagePurchaseOrders",
          component: ManagePurchaseOrders,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
  path: "/visitor/checkin/",
  name: "CheckinScreen",
  component: CheckinScreen,
  meta: {
    conditionalRoute: true,
    stopornot: IsUserAuthed,
    truePath: null,
    falsePath: "/"
  }
},{
  path: "/visitor/dashboard/",
  name: "OwnerDashboard",
  component: OwnerDashboard,
  meta: {
    conditionalRoute: true,
    stopornot: IsUserAuthed,
    truePath: null,
    falsePath: "/"
  }},

      {
    path: "/users/profile/:username",
    name: "UserProfile",
    component: UserProfile,
    meta: {
        conditionalRoute: true,
        stopornot: IsUserAuthed,
        truePath: null,
        falsePath: "/"
    }
},

{
  path: "/visitor/settings/",
  name: "VisitorSettings",
  component: VisitorSettings,
  meta: {
    conditionalRoute: true,
    stopornot: IsUserAuthed,
    truePath: null,
    falsePath: "/"
  }
},
{
  path: "/notifications/",
  name: "NotificationPage",
  component: NotificationPage,
  meta: {
    conditionalRoute: true,
    stopornot: IsUserAuthed,
    truePath: null,
    falsePath: "/"
  }
},
  //      {
  //   path: '/receiving/main/',
  //   name: 'ReceivingMain',
  //   component: ReceivingMain,
  //   meta: {
  //     title: 'Receiving'
  //   }
  // },
   {
            path: '/receiving/main/',
             name: 'ReceivingMain',
            component: ReceivingMain,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      // {
      //     path: "/products/categories/",
      //     name: "ListCategories",
      //     component: ListCategories,
      //     meta: {
      //         conditionalRoute: true,
      //         stopornot: IsUserAuthed,
      //         truePath: null,
      //         falsePath: "/"
      //     }
      // },
      // {
      //     path: "/products/vendors/",
      //     name: "ListVendors",
      //     component: ListVendors,
      //     meta: {
      //         conditionalRoute: true,
      //         stopornot: IsUserAuthed,
      //         truePath: null,
      //         falsePath: "/"
      //     }
      // },
      {
          path: "/products/catalog/",
          name: "ProductCatalog",
          component: ProductCatalog,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
    path: "/shipping/main/",
    name: "ShippingMain",
    component: ShippingMain,
    meta: {
        conditionalRoute: true,
        stopornot: IsUserAuthed,
        truePath: null,
        falsePath: "/"
    }
},
      {
          path: "/products/add/",
          name: "AddProducts",
          component: AddProducts,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/inventory/manage/",
          name: "ManageInventory",
          component: ManageInventory,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/inventory/by_location/",
          name: "InventoryByLocation",
          component: InventoryByLocation,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/inventory/main/",
          name: "InventoryMain",
          component: InventoryMain,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      // {
      //     path: "/users/manage/",
      //     name: "ManageUsers",
      //     component: ManageUsers,
      //     meta: {
      //         conditionalRoute: true,
      //         stopornot: IsUserAuthed,
      //         truePath: null,
      //         falsePath: "/"
      //     }
      // },
      {
          path: "/products/list/",
          name: "ListProducts",
          component: ListProducts,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/products/addgroup/",
          name: "AddProductGroup",
          component: AddProductGroup,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/products/lookup/",
          name: "LookupProduct",
          component: LookupProduct,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/products/view/",
          name: "ViewProduct",
          component: ViewProduct,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
        path: "/locations/list/",
        name: "ListLocations",
        component: ListLocations,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/locations/main/",
        name: "LocationsMain",
        component: LocationsMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      // {
      //   path: "/locations/sublocations/list/",
      //   name: "ListSublocations",
      //   component: ListSublocations,
      //   meta: {
      //       conditionalRoute: true,
      //       stopornot: IsUserAuthed,
      //       truePath: null,
      //       falsePath: "/"
      //   }
      // },
      {
        path: "/locations/manage/",
        name: "ManageLocations",
        component: ManageLocations,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/tools/delivery_zones/",
        name: "DeliveryZones",
        component: DeliveryZones,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/inventory_products/list/",
        name: "ListInventoryProducts",
        component: ListInventoryProducts,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/inventory_products/add/",
        name: "AddInventory",
        component: AddInventory,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/inventory_products/request/",
        name: "RequestItems",
        component: RequestItems,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/inventory_products/myrequests/",
        name: "MyRequests",
        component: MyRequests,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/inventory_products/trs/",
        name: "TransferRequests",
        component: TransferRequests,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      // {
      //   path: "/inventory_products/items_to_pull/",
      //   name: "ItemsToPull",
      //   component: ItemsToPull,
      //   meta: {
      //       conditionalRoute: true,
      //       stopornot: IsUserAuthed,
      //       truePath: null,
      //       falsePath: "/"
      //   }
      // },
      {
  path: "/customers/main/",
  name: "CustomerMain",
  component: CustomerMain,
  meta: {
    conditionalRoute: true,
    stopornot: IsUserAuthed,
    truePath: null,
    falsePath: "/"
  }
},
      {
        path: "/inventory_products/inv/",
        name: "Inventory",
        component: Inventory,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/tools/manage/",
        name: "ManageTools",
        component: ManageTools,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/tools/generate_pullist/",
        name: "GeneratePullist",
        component: GeneratePullist,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/tools/generate_delivery_list/",
        name: "DeliveryList",
        component: DeliveryList,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      // {
      //   path: "/delivery_list/:name/",
      //   name: "DeliveryList",
      //   component: DeliveryList,
      //   meta: {
      //       conditionalRoute: true,
      //       stopornot: IsUserAuthed,
      //       truePath: null,
      //       falsePath: "/"
      //   }
      // },
      {
        path: "/tools/pullists/",
        name: "ListPullists",
        component: ListPullists,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/tools/delivery_lists/",
        name: "ListDeliveryLists",
        component: ListDeliveryLists,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/tools/view_pullist/:name/",
        name: "ViewPullist",
        component: ViewPullist,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/sales/view_invoice/:invoice_id/",
        name: "NewSales",
        component: NewSales,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/purchase_orders/new/",
        name: "PurchaseOrder",
        component: PurchaseOrder,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/purchase_orders/:po_number/",
        name: "PurchaseOrder",
        component: PurchaseOrder,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/purchase_orders/",
        name: "ListPurchaseOrders",
        component: ListPurchaseOrders,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/special_orders/",
        name: "ListSpecialOrders",
        component: ListSpecialOrders,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/sales/",
        name: "Sales",
        component: Sales,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/tools/scanner/",
        name: "Scanner",
        component: Scanner,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/inventory_products/items_to_pickdrop/",
        name: "PickAndDrop",
        component: PickAndDrop,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/sales/newsale/",
        name: "NewSale",
        component: NewSale,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/sales/viewsale/:invoice_id/",
        name: "ViewSaleWrapper",
        component: ViewSaleWrapper,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/sales/lookupsale/",
        name: "LookupSale",
        component: LookupSale,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
          path: "/sales/listsales/",
          name: "ListSales",
          component: ListSales,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/sales/refunds/",
          name: "Refunds",
          component: Refunds,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/sales/process_refunds/",
          name: "ProcessRefunds",
          component: ProcessRefunds,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
      },
      {
          path: "/sales/my_customer_deliveries/",
          name: "MyCustomerDeliveries",
          component: MyCustomerDeliveries,
          meta: {
              conditionalRoute: true,
              stopornot: IsUserAuthed,
              truePath: null,
              falsePath: "/"
          }
          
      },
      // ✅ NEW ROUTE ADDED HERE
{
  path: "/sales/draft-customer-info/",  // This has trailing slash
  name: "DraftCustomerInfo",
  component: () => import("@/components/Sales/DraftCustomerInfo.vue"),
  meta: {
    conditionalRoute: true,
    stopornot: IsUserAuthed,
    truePath: null,
    falsePath: "/"
  }
},
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
      {
        path: "/receiving/floor_samples/",
        name: "ReceivingFloorSamples",
        component: ReceivingFloorSamples,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/receiving/inventory/",
        name: "ReceivingInventory",
        component: ReceivingInventory,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/receiving/customer_pickup/",
        name: "ReceivingCustomerPickup",
        component: ReceivingCustomerPickup,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/shipping/customer_pickup/",
        name: "ShippingCustomerPickup",
        component: ShippingCustomerPickup,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/shipping/items_shipped/",
        name: "ShippingItemsShipped",
        component: ShippingItemsShipped,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/shipping/items_to_pull/",
        name: "ShippingItemsToPull",
        component: ShippingItemsToPull,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/admin_tools/open_requests/",
        name: "AdminToolsOpenRequests",
        component: AdminToolsOpenRequests,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/create_pullist/",
        name: "AdminToolsCreatePullist",
        component: AdminToolsCreatePullist,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/items_to_be_pulled/",
        name: "AdminToolsItemsToBePulled",
        component: AdminToolsItemsToBePulled,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/items_to_be_picked/",
        name: "AdminToolsItemsToBePicked",
        component: AdminToolsItemsToBePicked,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/all_orders/",
        name: "AdminToolsAllOrders",
        component: AdminToolsAllOrders,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/all_orders2/",
        name: "AdminToolsAllOrders2",
        component: AdminToolsAllOrders2,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/main/",
        name: "AdminToolsMain",
        component: AdminToolsMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
    path: "/admin/approve-non-inventory/:invoiceId?",
    name: "AdminApproval",
    component: AdminApproval,
    meta: {
        conditionalRoute: true,
        stopornot: IsUserAuthed,
        truePath: null,
        falsePath: "/"
    }
},
         {
        path: "/DeliveryCalendar/main/",
        name: "DeliveryCalendarMain",
        component: DeliveryCalendarMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/incoming_outgoing/main/",
        name: "ShippingReceivingMain",
        component: ShippingReceivingMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/products/main/",
        name: "ProductsMain",
        component: ProductsMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/sales/main/",
        name: "SalesMain",
        component: SalesMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },


      {
        path: "/admin_tools/mark_items_ready_to_ship/",
        name: "AdminToolsMarkItemsReadyToShip",
        component: AdminToolsMarkItemsReadyToShip,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/create_deliveries/",
        name: "AdminToolsCreateDeliveries",
        component: AdminToolsCreateDeliveries,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/home_deliveries/",
        name: "AdminToolsHomeDeliveries",
        component: AdminToolsHomeDeliveries,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/store_pickups/",
        name: "AdminToolsStorePickups",
        component: AdminToolsStorePickups,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/store_transfers/",
        name: "AdminToolsStoreTransfers",
        component: AdminToolsStoreTransfers,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/vendor_orders/",
        name: "AdminToolsVendorOrders",
        component: AdminToolsVendorOrders,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/process_deliveries/",
        name: "AdminToolsProcessDeliveries",
        component: AdminToolsProcessDeliveries,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/admin_tools/process_pickups/",
        name: "AdminToolsProcessPickups",
        component: AdminToolsProcessPickups,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/incoming_outgoing/incoming/",
        name: "IncomingOutGoingIncoming",
        component: IncomingOutGoingIncoming,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/incoming_outgoing/outgoing/",
        name: "IncomingOutGoingOutGoing",
        component: IncomingOutGoingOutGoing,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/incoming_outgoing/",
        name: "IncomingOutgoing",
        component: IncomingOutgoing,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/incoming_outgoing/items_to_pull/",
        name: "ItemsToPull",
        component: ItemsToPull,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/incoming_outgoing/deliveries_loading/",
        name: "DeliveriesLoading",
        component: DeliveriesLoading,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/incoming_outgoing/deliveries_shipping/",
        name: "DeliveriesShipping",
        component: DeliveriesShipping,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },


      {
        path: "/inventory/lookup_inventory/",
        name: "LookupInventory",
        component: LookupInventory,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/customer_service/main/",
        name: "CustomerServiceMain",
        component: CustomerServiceMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/customer_service/cs_ticket/",
        name: "CSTicket",
        component: CSTicket,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/products/list_products/",
        name: "ProductsListProducts",
        component: ProductsListProducts,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      // {
      //   path: "/reports/reports_v1/",
      //   name: "ReportsReportsV1",
      //   component: ReportsReportsV1,
      //   meta: {
      //       conditionalRoute: true,
      //       stopornot: IsUserAuthed,
      //       truePath: null,
      //       falsePath: "/"
      //   }
      // },
      // {
      //   path: "/reports/stores_sale/",
      //   name: "ReportsStoresSale",
      //   component: ReportsStoresSale,
      //   meta: {
      //       conditionalRoute: true,
      //       stopornot: IsUserAuthed,
      //       truePath: null,
      //       falsePath: "/"
      //   }
      // },
      // {
      //   path: "/reports/reports_v3/",
      //   name: "ReportsMySales",
      //   component: ReportsMySales,
      //   meta: {
      //       conditionalRoute: true,
      //       stopornot: IsUserAuthed,
      //       truePath: null,
      //       falsePath: "/"
      //   }
      // },
      // {
      //   path: "/reports/reports_v4/",
      //   name: "ReportsRefunds",
      //   component: ReportsRefunds,
      //   meta: {
      //       conditionalRoute: true,
      //       stopornot: IsUserAuthed,
      //       truePath: null,
      //       falsePath: "/"
      //   }
      // },
      {
        path: "/reports/main/",
        name: "ReportsMain",
        component: ReportsMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
  path: "/product-reports/main/",
  name: "ProductReportsMain",
  component: () => import("@/components/ProductReports/ProductReportsMain.vue"),
  meta: {
    conditionalRoute: true,
    stopornot: IsUserAuthed,
    truePath: null,
    falsePath: "/"
  }
},

      {
        path: "/users/list_users/",
        name: "ListUsers",
        component: ListUsers,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/users/main/",
        name: "UsersMain",
        component: UsersMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/deliveries/list_deliveries/",
        name: "DeliveriesListDeliveries",
        component: DeliveriesListDeliveries,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/store_transfers/new_transfer/",
        name: "NewTransfer",
        component: NewTransfer,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      {
        path: "/control_panel/main/",
        name: "ControlPanelMain",
        component: ControlPanelMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/vendor_orders/main/",
        name: "VendorOrdersMain",
        component: VendorOrdersMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/transfer_orders/main/",
        name: "TransferOrdersMain",
        component: TransferOrdersMain,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },
      {
        path: "/sales/edit_invoice/",
        name: "EditInvoiceWrapper",
        component: EditInvoiceWrapper,
        meta: {
            conditionalRoute: true,
            stopornot: IsUserAuthed,
            truePath: null,
            falsePath: "/"
        }
      },

      // {
      //   path: '*',
      //   name: 'fourOfour',
      //   component: fourOfour
      // },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js